import { Role, TripState, User } from "../../../models";
import { TripEconomicData } from "../../../models/trip-economics.model";

/**
 * Tells whether the given user can modify (edit, copy, delete) the given trip economic.
 * Rule: an ACCOUNTANT can only view the trip economics of an EXPIRED trip.
 * Missing user, role or trip state never restrict the access (role visibility is handled elsewhere).
 */
export function isTripEconomicEditableBy(user: User | undefined, tripEconomic: Pick<TripEconomicData, 'tripState'> | undefined): boolean {
    const role = user?.userAttributes?.['custom:role'];
    return !(role === Role.ACCOUNTANT && tripEconomic?.tripState === TripState.EXPIRED);
}
